/* eslint-disable max-len */
import React from 'react'

const NoItemsIcon = () => (
  <svg
    width='88'
    height='88'
    viewBox='0 0 88 88'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.838 27.5148C17.838 27.5148 8.80045 26.2476 8.80045 12.6514C8.80045 12.6514 25.2524 6.25414 30.6389 21.3744M37.3997 8.8V20.9136M57.6176 30.0206C54.9619 27.3458 51.8095 25.2245 48.3406 23.7779C44.8716 22.3312 41.154 21.5876 37.4 21.5894C33.646 21.5876 29.9283 22.3312 26.4594 23.7778C22.9904 25.2245 19.8381 27.3458 17.1823 30.0206C14.5265 32.6954 12.4194 35.8714 10.9811 39.3672C9.54291 42.863 8.80174 46.6101 8.79997 50.3947C8.80174 54.1793 9.54291 57.9264 10.9811 61.4222C12.4194 64.918 14.5265 68.094 17.1823 70.7688C19.8381 73.4437 22.9904 75.5649 26.4594 77.0116C29.9283 78.4582 33.646 79.2018 37.4 79.2C41.154 79.2018 44.8716 78.4582 48.3406 77.0115'
      stroke='#C12700'
      strokeWidth='3.3'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M77.9289 42.8755L53.8756 66.9289M83.6 55C83.6 64.7202 75.7202 72.6 66 72.6C56.2798 72.6 48.4 64.7202 48.4 55C48.4 45.2798 56.2798 37.4 66 37.4C75.7202 37.4 83.6 45.2798 83.6 55Z'
      stroke='#C12700'
      strokeWidth='3.3'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default NoItemsIcon
